/**
 * DADDL claims showcase — <daddl-claims-showcase>.
 * One product block at a time, picked from a row of pack cutouts (one per
 * Product block, aria-pressed on the current one). Each block has a slide
 * (the bag) and a buy row; both stacks switch together. Slides are
 * stacked in one grid cell and crossfade via .is-active, so there is no
 * scroll axis and nothing to mirror under RTL. The bag's reveal is the X-ray
 * lens (daddl-pack-xray: hover on desktop, scroll on touch). Picking a
 * flavour replays that bag's hover intro.
 * Theme editor: selecting a Product block brings its slide forward.
 */
if (!customElements.get('daddl-claims-showcase')) {
  customElements.define(
    'daddl-claims-showcase',
    class DaddlClaimsShowcase extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-claims-slide]'));
        if (!this.slides.length) return;

        this.thumbs = Array.from(this.querySelectorAll('[data-claims-thumb]'));
        this.buys = Array.from(this.querySelectorAll('[data-claims-buy]'));
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));

        this.onClick = this.onClick.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.addEventListener('click', this.onClick);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onClick(event) {
        const thumb = event.target.closest('[data-claims-thumb]');
        if (thumb) this.go(Number(thumb.dataset.claimsThumb));
      }

      onBlockSelect(event) {
        const slide = event.target.closest && event.target.closest('[data-claims-slide]');
        const index = slide ? this.slides.indexOf(slide) : -1;
        if (index >= 0) this.go(index);
      }

      /** Activate slide i and sync the thumbnail pressed state (the thumb label names the product). */
      go(i) {
        if (!this.slides[i] || i === this.index) return;

        this.slides[this.index].classList.remove('is-active');
        this.slides[i].classList.add('is-active');
        this.buys[this.index]?.classList.remove('is-active');
        this.buys[i]?.classList.add('is-active');
        this.thumbs.forEach((thumb, t) => {
          thumb.classList.toggle('is-active', t === i);
          thumb.setAttribute('aria-pressed', t === i ? 'true' : 'false');
        });
        this.index = i;

        const xray = this.slides[i].querySelector('daddl-pack-xray');
        if (xray && typeof xray.playIntro === 'function') xray.playIntro();
      }
    }
  );
}
